import React from "react";
import styled from "styled-components";
import { useTrainingStore } from "../../stores/trainingStore";

const ControlWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 30px;
`;

const Button = styled.button<{ $main?: boolean }>`
  background: ${(props) =>
    props.$main ? "var(--text-main)" : "rgba(255,255,255,0.1)"};
  color: ${(props) => (props.$main ? "black" : "white")};
  border: none;
  border-radius: 30px;
  padding: 16px 32px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:active {
    transform: scale(0.95);
  }
`;

export const TimerControls: React.FC = () => {
  const {
    isActive,
    isPaused,
    startTraining,
    pauseTraining,
    resumeTraining,
    stopTraining,
  } = useTrainingStore();
  return (
    <ControlWrapper>
      {!isActive ? (
        <Button $main onClick={startTraining}>
          ▶ START
        </Button>
      ) : (
        <>
          {isPaused ? (
            <Button $main onClick={resumeTraining}>
              ▶ RESUME
            </Button>
          ) : (
            <Button $main onClick={pauseTraining}>
              Ⅱ PAUSE
            </Button>
          )}
          <Button onClick={stopTraining}>■ STOP</Button>
        </>
      )}
    </ControlWrapper>
  );
};
